import axios from 'axios';
import ElementUI from 'element-ui';
import {
  VueAxios
} from './axios';
import g from '../api/globalVariable';
import { logout } from '../api/user';

// 防止多个401同时触发跳转
let isRedirecting = false;

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: '',
  timeout: 8000 // 请求超时时间
})

// 拦截器
request.interceptors.request.use(config => {
  const token = sessionStorage.getItem('LocalToken'); // 问卷系统的token
  // 如果token存在，则每个请求携带token
  if (token) {
    config.headers['token'] = token
  }
  return config
}, err => {
  return Promise.reject(err)
})

// response interceptor
request.interceptors.response.use((response) => {
  const res = response.data;
  
  // 处理业务 code 为 401 的情况
  if (res && res.code === 401) {
      if (isRedirecting) {
        return Promise.reject(new Error('无权访问！'));
      }
      isRedirecting = true;
      
      const token = sessionStorage.getItem('token');
      const redirect_uri = encodeURIComponent(g.AUTH_INDEX);
      const ssoUrl = `${g.AUTHORIZE_NET}?response_type=code&client_id=${g.CLIENT_ID}&redirect_uri=${redirect_uri}&state=authapi_index`;
      
      if (token) {
        // 已登录但权限失效，弹窗提示后跳转
        logout(token).catch(() => {});
        sessionStorage.clear();
        ElementUI.MessageBox.alert('无权访问！', '提示', {
          confirmButtonText: '确定',
          type: 'error',
          callback: () => {
            location.href = ssoUrl;
          }
        });
      }else{
        location.href = ssoUrl;
        return;
      }
      return Promise.reject(new Error('无权访问！'));
  }
  
  return res;
}, err => {
  // if (!err.response) {
  //   ElementUI.Message({
  //     type: 'error',
  //     duration: 2000,
  //     offset: 100,
  //     message: `接口响应失败，请刷新浏览器重试。错误原因：${err}`,
  //   })
  //   return Promise.resolve(err)
  // }
  switch(err.response.status) {
    case 401:
      if (isRedirecting) {
        break;
      }
      isRedirecting = true;
      
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('LocalToken')
      sessionStorage.removeItem('user')
      sessionStorage.removeItem('store');
      const redirect_uri = encodeURIComponent(g.AUTH_INDEX);
      const ssoUrl = `${g.AUTHORIZE_NET}?response_type=code&client_id=${g.CLIENT_ID}&redirect_uri=${redirect_uri}&state=authapi_index`;
      
      ElementUI.MessageBox.alert('登录超时，请重新登录', '提示', {
        confirmButtonText: '确定',
        type: 'error',
        callback: () => {
          location.href = ssoUrl;
        }
      });
      break;
    case 500:
      ElementUI.Message({
        type: 'error',
        duration: 3000,
        offset: 100,
        message: '服务器内部错误'
      });
      break;
    default:
      return Promise.reject(err);
  }
  return err
})

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
};

